import Approach from '../Components/Approach';
import Hero from '../Components/Hero';
import WhyChooseUs from '../Components/WhyChooseUs';

function Home() {
  return (
    <main>
      <Hero />
      <Approach />
      <WhyChooseUs />
    </main>
  );
}

export default Home;
